var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 1C1.89543 1 1 1.89543 1 3V13C1 14.1046 1.89543 15 3 15H4V19L8 15H17C18.1046 15 19 14.1046 19 13V3C19 1.89543 18.1046 1 17 1H3Z",
    fill: "#006CFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 15H5C5 14.4477 4.55228 14 4 14V15ZM4 19H3C3 19.4045 3.24364 19.7691 3.61732 19.9239C3.99099 20.0787 4.42111 19.9931 4.70711 19.7071L4 19ZM8 15V14C7.73478 14 7.48043 14.1054 7.29289 14.2929L8 15ZM2 3C2 2.44772 2.44772 2 3 2V0C1.34315 0 0 1.34315 0 3H2ZM2 13V3H0V13H2ZM3 14C2.44772 14 2 13.5523 2 13H0C0 14.6569 1.34315 16 3 16V14ZM4 14H3V16H4V14ZM5 19V15H3V19H5ZM7.29289 14.2929L3.29289 18.2929L4.70711 19.7071L8.70711 15.7071L7.29289 14.2929ZM17 14H8V16H17V14ZM18 13C18 13.5523 17.5523 14 17 14V16C18.6569 16 20 14.6569 20 13H18ZM18 3V13H20V3H18ZM17 2C17.5523 2 18 2.44772 18 3H20C20 1.34315 18.6569 0 17 0V2ZM3 2H17V0H3V2Z",
    fill: "#006CFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6L15 6",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10H13",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15V14C8.44772 14 8 14.4477 8 15H9ZM16 19L16.7071 18.2929C16.5196 18.1054 16.2652 18 16 18V19ZM20 23L19.2929 23.7071C19.5789 23.9931 20.009 24.0787 20.3827 23.9239C20.7564 23.7691 21 23.4045 21 23H20ZM20 19V18C19.4477 18 19 18.4477 19 19H20ZM19 9V8C18.4477 8 18 8.44772 18 9H19ZM10 17V15H8V17H10ZM11 18C10.4477 18 10 17.5523 10 17H8C8 18.6569 9.34315 20 11 20V18ZM16 18H11V20H16V18ZM20.7071 22.2929L16.7071 18.2929L15.2929 19.7071L19.2929 23.7071L20.7071 22.2929ZM19 19V23H21V19H19ZM21 18H20V20H21V18ZM22 17C22 17.5523 21.5523 18 21 18V20C22.6569 20 24 18.6569 24 17H22ZM22 11V17H24V11H22ZM21 10C21.5523 10 22 10.4477 22 11H24C24 9.34315 22.6569 8 21 8V10ZM19 10H21V8H19V10ZM18 9V13H20V9H18ZM18 13C18 13.5523 17.5523 14 17 14V16C18.6569 16 20 14.6569 20 13H18ZM17 14H9V16H17V14Z",
    fill: "#006CFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatActive);
export default __webpack_public_path__ + "static/media/chat-active.0074d2b88e4877339de589b19da39500.svg";
export { ForwardRef as ReactComponent };